module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/check-aab04574319616a3bcc73a9ec8daf75a.png";